import { render, staticRenderFns } from "./tbunitbisnis.vue?vue&type=template&id=1030cd1a"
import script from "./tbunitbisnis.vue?vue&type=script&lang=js"
export * from "./tbunitbisnis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports